import { configData } from "../config";

// The URL Restriction checkboxes of the edit forms, with the site names live's forms show
export const URL_RESTRICTIONS = [
    { value: configData.RSMWW_DOMAIN, label: 'SportsManagementWorldwide.com' },
    { value: configData.RSMWW_AGENCY_DOMAIN, label: 'SMWWAgency.com' },
    { value: configData.RSMWW_SCOUT_DOMAIN, label: 'SMWWScout.com' },
];

// The checkboxes ticked for the stored domains. Pages saved here store this site's domains as a
// list; a page migrated from Drupal stores live's domain (www.sportsmanagementworldwide.com) as
// text, so each domain goes to the checkbox of the site it names, as CourseFields.js reads them.
export const urlRestrictionChoices = (value) => {
    let domains = [];
    if (Array.isArray(value)) {
        domains = value;
    } else if (value) {
        try {
            const list = JSON.parse(value);
            domains = Array.isArray(list) ? list : [String(value)];
        } catch (e) {
            domains = String(value).split(',');
        }
    }
    const site = (domain) => /agency/i.test(domain) ? 1 : /scout/i.test(domain) ? 2 : 0;
    const ticked = domains.map((domain) => String(domain).trim()).filter(Boolean).map(site);
    return URL_RESTRICTIONS.filter((choice, index) => ticked.includes(index)).map((choice) => choice.value);
};

// The site names of the ticked domains, in the checkboxes' order
export const urlRestrictionLabels = (values) =>
    URL_RESTRICTIONS.filter((choice) => (values || []).includes(choice.value)).map((choice) => choice.label).join(', ');
